import { ErrorCode, reportError } from '@ms/yammer-data/dist/telemetry';
import React, { ComponentType, PureComponent } from 'react';

import { ErrorBoundaryName } from './types';

export type ErrorComponent = ComponentType<{ readonly error?: unknown }>;

export interface ErrorBoundaryProps {
  readonly name: ErrorBoundaryName;
  readonly ErrorComponent: ErrorComponent;
}

export interface ErrorBoundaryState {
  readonly error: unknown;
}

export default class ErrorBoundary extends PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    error: undefined,
  };

  public static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  public componentDidCatch(error: unknown) {
    reportError({
      error,
      eventProperties: {
        errorBoundaryName: this.props.name,
        errorCode: ErrorCode.ErrorBoundary,
      },
    });
  }

  public render() {
    const { ErrorComponent: Error, children } = this.props;

    return this.state.error ? (
      <div className="qaErrorBoundary">
        <Error error={this.state.error} />
      </div>
    ) : (
      children
    );
  }
}
